import Nullstack from 'nullstack';
export default function IconVectorBezier({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vector-bezier",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "14",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "17",
    y: "14",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "6",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M10 8.5a6 6 0 0 0 -5 5.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 8.5a6 6 0 0 1 5 5.5"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "8",
    x2: "4",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "8",
    x2: "14",
    y2: "8"
  }), "   ", Nullstack.element("circle", {
    cx: "3",
    cy: "8",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "21",
    cy: "8",
    r: "1"
  }), " ");
}